import {GET_DASHBOARD_DATA} from '../../../shared/constants/ActionTypes';

const initialState = {
  dashboardData: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload,
      };

    default:
      return state;
  }
};
